import { render, staticRenderFns } from "./export.vue?vue&type=template&id=38de8a09&scoped=true&"
import script from "./export.vue?vue&type=script&lang=js&"
export * from "./export.vue?vue&type=script&lang=js&"
import style0 from "./export.vue?vue&type=style&index=0&id=38de8a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38de8a09",
  null
  
)

export default component.exports